import React from 'react'

import FeatureCheck from 'components/FeatureCheck'

import classes from './PricingOptions.module.scss'

/** @type {import("./types").default} */
const PricingOptions = ({ pricing }) => {
  const isChecked = feature => pricing.categories.includes(feature)

  return (
    <div className={classes.featureChecks}>
      <FeatureCheck checked={isChecked('free-trial')}>Free trial</FeatureCheck>
      <FeatureCheck checked={isChecked('free')}>Free version</FeatureCheck>
    </div>
  )
}

export default PricingOptions
